/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import DrawerModal, { VaulDrawer } from 'builder/components/DrawerModal/DrawerModal'
import { Icon20 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'
import { TabItem, Container, ConnectorLine } from '../styles'
import { CategoryIds, useCategoryTabsContext } from '..'

const List = styled.ul`
  padding: 0;
  margin-bottom: 48px;
  margin-top: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  width: 100%;
`
const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Wrapper = styled.div`
  padding: 0 16px;
  text-align: center;
`

const Title = styled(VaulDrawer.Drawer.Title)`
  width: 255px;
  margin: 0 auto;
  padding: 8px 20px 16px 20px;
  ${Typography.S};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`

export default function CategoryDrawer(props: {
  items: { id: CategoryIds; label: string; element: React.ReactNode }[]
}) {
  const [isOpen, setIsOpen] = React.useState(false)
  const { activeTab, setActiveTab } = useCategoryTabsContext()
  const activeItem = props.items.find(i => i.id === activeTab)
  const activeIndex = props.items.findIndex(i => i.id === activeTab)

  return (
    <Container>
      <DrawerModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        trigger={
          <TabItem isActive={isOpen} onClick={() => setIsOpen(!isOpen)}>
            {activeItem?.label}
            {isOpen ? <Icon20.ChevronUp /> : <Icon20.ChevronDown />}
          </TabItem>
        }
      >
        <Wrapper>
          <VaulDrawer.Handle style={{ marginTop: '8px' }} />
          <Title>Where are you on your career journey today?</Title>
          <List>
            {props.items.map((item, index) => {
              const showLine = index < props.items.length - 1
              const isBeforeActive = index === activeIndex - 1
              const isAfterActive = index === activeIndex
              const isGradientLine = isBeforeActive || isAfterActive
              return (
                <ListItem key={item.id}>
                  <TabItem
                    isActive={activeTab === item.id}
                    width="100%"
                    onClick={() => {
                      setActiveTab(item.id)
                      setIsOpen(false)
                    }}
                  >
                    {item.label}
                  </TabItem>
                  {showLine && (
                    <ConnectorLine
                      layout="vertical"
                      gradient={
                        isGradientLine
                          ? isAfterActive
                            ? 'top-to-bottom'
                            : 'bottom-to-top'
                          : undefined
                      }
                    />
                  )}
                </ListItem>
              )
            })}
          </List>
        </Wrapper>
      </DrawerModal>
    </Container>
  )
}
